import toast from 'react-hot-toast';
import Axios from '../services/axios';

export const labFetchData = async (method = 'POST', url, payload = {}, showError = true) => {
  try {
    const methods = {
      POST: () => Axios.post(url, payload),
      GET: () => Axios.get(url),
      PUT: () => Axios.put(url, payload),
      DELETE: () => Axios.delete(url, { data: payload })
    };

    if (methods[method]) {
      const response = await methods[method]();
      return response?.data;
    } else {
      throw new Error(`Unsupported HTTP method: ${method}`);
    }
  } catch (error) {
    console.log(error);
    if (showError) {
      toast.error(error?.response?.data?.error || error?.response?.data?.message || `Error`);
    }
    return null;
  }
};
